var map = {
	"./Hole1.png": 10741,
	"./Hole2.png": 95575,
	"./Hole3.png": 82302,
	"./Page1.png": 32774,
	"./Page2.png": 19107,
	"./Page3.png": 20995,
	"./Page4.png": 92672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6885;